/* eslint-disable no-shadow */
import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import GridItem from '../Grid/GridItem';
import Typography from '../Typography/CustomTypography';
import Button from '../Button/CustomButton';
import { RadioButtonIcon } from '../Icons/Icon';
import withAuthUser from '../../common/WithAuthUser';
import styles from '../../assets/jss/components/freeLogin';

import { FreeLoginRequested } from '../../actions/Auth';

const useStyles = makeStyles(styles);

const FreeLogin = ({ freeLogin, eventInfo, customColor }) => {
    const classes = useStyles();
    const params = useParams();
    const history = useHistory();
    const intl = useIntl();

    const handleFreeLogin = () => {
        const { shortName } = params;
        const { free_seminar, free_live_stream, free_exhibition } = eventInfo;
        if (freeLogin) {
            freeLogin({
                shortName, free_seminar, free_live_stream, free_exhibition,
            });
            history.push(`/${shortName}/home`);
        }
    };

    const renderTextFree = () => {
        const freeLogin = [
            {
                text: eventInfo.settings_texts_sidebar_viewer?.field_name?.exhibitor_info_list || intl.formatMessage({ id: 'exhibited.products' }),
                value: eventInfo.has_exhibition && eventInfo.free_exhibition,
            },
            {
                text: eventInfo.settings_texts_sidebar_viewer?.field_name?.seminar_list || intl.formatMessage({ id: 'login.seminars' }).toLocaleLowerCase(),
                value: eventInfo.has_seminar && eventInfo.free_seminar,
            },
            {
                text: eventInfo.settings_texts_sidebar_viewer?.field_name?.livestreaming || intl.formatMessage({ id: 'userRouters.liveStream' }).toLocaleLowerCase(),
                value: eventInfo.has_live_stream && eventInfo.free_live_stream,
            },
        ];
        let count = 0;

        freeLogin.forEach((item) => {
            count = item.value ? count + 1 : count;
        });

        const arrFree = freeLogin.filter((item) => item.value);

        if (count === 1) {
            return intl.formatMessage({ id: 'home.textLoginFreeOnePage' }, { freeOnePage: `${arrFree[0].text}` });
            // return `「フリー入場する」ボタンを押すと、${arrFree[0].text}が見れます。（入場申込みは不要です）`;
        }
        if (count === 2) {
            return intl.formatMessage({ id: 'home.textLoginFreeTwoPage' }, { freeOnePage: `${arrFree[0].text}`, freeTwoPage: `${arrFree[1].text}` });
            // return `「フリー入場する」ボタンを押すと、${arrFree[0].text}や${arrFree[1].text}などが見れます。（入場申込みは不要です）`;
        }
        if (count === 3) {
            return intl.formatMessage({ id: 'home.textLoginFreeAllPage' }, {
                freeExhibition: `${arrFree[0].text}` || intl.formatMessage({ id: 'exhibited.products' }),
                freeSeminar: `${arrFree[1].text}` || intl.formatMessage({ id: 'login.seminars' }).toLocaleLowerCase(),
                freeLivestream: `${arrFree[2].text}` || intl.formatMessage({ id: 'userRouters.liveStream' }).toLocaleLowerCase(),
            });
            // return `「フリー入場する」ボタンを押すと、${arrFree[0].text || '展示商品'}、${arrFree[1].text || 'セミナー'}、${arrFree[2].text || 'ライブ配信'}が見れます。（入場申込みは不要です）`;
        }
    };

    return (
        <GridItem container item className={!eventInfo.outer_server_activation ? classes.wrapper : classes.allCenter}>
            <GridItem xs={12} lg={6}>
                <div className={!eventInfo.outer_server_activation ? classes.centerToRight : classes.flexStart}>
                    <Button
                        color="info"
                        gradient
                        className={classes.buttonBig}
                        round
                        onClick={handleFreeLogin}
                        buttonTextColor={eventInfo?.settings_colors_viewer?.button_text_color}
                        buttonBackgroundColor={eventInfo?.settings_colors_viewer?.button_background_color?.viewer}
                    >
                        {intl.formatMessage({ id: 'home.loginFree' })}
                    </Button>
                </div>
            </GridItem>
            <GridItem xs={12} lg={6}>
                <Box display="flex" className={classes.helperText}>
                    <RadioButtonIcon color={customColor?.button_background_color?.viewer || '#4facfe'} />
                    <Typography variant="subtitle1" customColor={customColor?.contents_text_color}>
                        {renderTextFree()}
                    </Typography>
                </Box>
            </GridItem>
        </GridItem>
    );
};

const mapStateToProps = (state) => ({
    eventInfo: state.registration.registrationViewer.data,
});

const mapDispatchToProps = (dispatch) => ({
    freeLogin: (params) => {
        dispatch(FreeLoginRequested(params));
    },
});

FreeLogin.defaultProps = {
    eventInfo: {},
    customColor: {},
};

FreeLogin.propTypes = {
    freeLogin: PropTypes.func.isRequired,
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    customColor: PropTypes.oneOfType([() => null, PropTypes.object]),
};

export default compose(
    withAuthUser,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(FreeLogin);
